// Efeito de fade out em um elemento HTML
export default (el, duration, callback) => {
  let interval = duration / 10
  let fadeEffect = setInterval(() => {
    if (!el.style.opacity) {
      el.style.opacity = 1
    }

    if (el.style.opacity > 0) {
      el.style.opacity -= 0.1
    } else {
      clearInterval(fadeEffect)
      el.style.display = 'none'
      callback()
    }
  }, interval)
}
